import { generatePath } from 'react-router-dom'
import {
  CUSTOMERS,
  CUSTOMERS_INFO,
  CUSTOMERS_UPDATE,
  CUSTOMERS_CREATE,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestCustomersList = async (page, filters = {}) => {
  const params = page > 1 ? { params: { page, ...filters } } : { params: filters }

  const response = await request.get(CUSTOMERS, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}

export const requestSearchCustomer = async (search) => (
  requestCustomersList(0, { search, per: 10 })
)

export const requestCustomerInfo = async (id) => {
  const path = generatePath(CUSTOMERS_INFO, { id })

  const response = await request.get(path)
    .then((resp) => resp.data)
    .catch((error) => {
      let message = 'Houve um erro ao buscar cliente'
      if (error?.response?.status === 404) {
        message = 'Cliente não encontrado'
      }

      return formatError(error, message)
    })

  return response
}

export const requestCustomerUpdate = async (id, customer) => {
  const path = generatePath(CUSTOMERS_UPDATE, { id })

  const response = await request.patch(path, customer)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}

export const requestCustomerCreate = async (params) => {
  const response = await request.post(CUSTOMERS_CREATE, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}
